<template>
  <v-card :shaped="true">
    <v-card-text :class="type">
      <v-container no-gutters class="pa-0">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-icon left>{{getNotificationIcon(type)}}</v-icon>
          </v-col>
          <v-col>
            <v-flex class="d-inline-flex">
              {{text}}
              <v-btn v-if="link" icon :to="link" class="align-start"><v-icon>mdi-link</v-icon></v-btn>
            </v-flex>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";

export default {
  name: "Alert",
  mixins: [commonMixin],
  components: {},
  props: {
    text: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: "info"
    },
    link: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      showTooltip: false
    };
  },
  methods: {}
};
</script>